import React from "react";
import ReactPaginate from "react-paginate";
export function Pagination({
    startItem,
    endItem,
    totalItems,
    pageCount,
    handlePageChange,
    page
}) {
    return <>
        <div className="left-f">
            <h6>SHOWING {startItem}-{endItem} OF {totalItems}</h6>
        </div>
        <div className="right-f">
            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    <ReactPaginate 
                    previousLabel={
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M10 13L5 8L10 3" stroke="#8C8C8C" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    }
                     nextLabel={
                     <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M5 13L10 8L5 3" stroke="#8C8C8C" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    }
                        pageClassName="page-item" pageLinkClassName="page-link" previousClassName="page-item" previousLinkClassName="page-link" nextClassName="page-item" nextLinkClassName="page-link" breakLabel="..." breakClassName="page-item" breakLinkClassName="page-link"
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={page} />
                </ul>
            </nav>
        </div>
    </>;
}
